import { RouteConfig, SideLink } from '@/types/utility.types'
import { IconPhotoMinus } from '@tabler/icons-react'

export const bannerModuleKey = 'banner'

const bannerRoute: RouteConfig = {
  uid: bannerModuleKey,
  path: 'banner',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/banner')).default,
  }),
}

const createBannerRoute: RouteConfig = {
  uid: bannerModuleKey,
  path: 'banner/create',
  type: 'create',
  lazy: async () => ({
    Component: (await import('@/pages/banner/create-banner')).default, // Create banner page
  }),
}

const editBannerRoute: RouteConfig = {
  uid: bannerModuleKey,
  path: 'banner/:bannerId',
  type: 'update',
  lazy: async () => ({
    Component: (await import('@/pages/banner/edit-banner')).default,
  }),
}

export const sidelink: SideLink = {
  uid: bannerModuleKey,
  title: 'Banners',
  href: '/banner',
  icon: <IconPhotoMinus size={18} />,
  order: 9,
}

export default [bannerRoute, createBannerRoute, editBannerRoute]
